/*
    创建者：shuxiaokai
    创建时间：2020-05-06 08:44
    模块名称：拖拽缩放框
    备注：xxxx
*/
<template>
    <div 
            class="s-drag-bar"
            :style="{ left: left + 'px', top: top + 'px', width: width + 'px', height: height + 'px' }"
            @mouseup="handleClearMousemove"
    >
        <div class="dot l" @mousedown.stop.prevent="resizeDOM($event, 'left')"></div>
        <div class="dot r" @mousedown.stop.prevent="resizeDOM($event, 'right')"></div>
        <div class="dot t" @mousedown.stop.prevent="resizeDOM($event, 'top')"></div>
        <div class="dot b" @mousedown.stop.prevent="resizeDOM($event, 'bottom')"></div>
        <div class="dot lt" @mousedown.stop.prevent="resizeDOM($event, 'leftTop')"></div>
        <div class="dot lb" @mousedown.stop.prevent="resizeDOM($event, 'leftBottom')"></div>
        <div class="dot rt" @mousedown.stop.prevent="resizeDOM($event, 'rightTop')"></div>
        <div class="dot rb" @mousedown.stop.prevent="resizeDOM($event, 'rightBottom')"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            startX: 0,
            startY: 0,
            startLeft: 0, //鼠标点击时候的left值
            startTop: 0, //鼠标点击时候的top值
            startWidth: 0, //鼠标点击时候的width值
            startHeight: 0, //鼠标点击时候的height值
        };
    },
    computed: {
        selectWidgetId() {
            return this.$store.state.widget.selectWidgetId;
        },
        currentWidget() {
            return this.$store.state.widget.widgetList.find(val => val.id === this.selectWidgetId);
        },
        width() {
            const currentWidget = this.$store.state.widget.widgetList.find(val => val.id === this.selectWidgetId);
            if (!currentWidget) {
                return 0;
            } 
            return currentWidget.boundingClientRect.width;
        },
        height() {
            const currentWidget = this.$store.state.widget.widgetList.find(val => val.id === this.selectWidgetId);
            if (!currentWidget) {
                return 0;
            }
            return currentWidget.boundingClientRect.height;
        },
        left() {
            const currentWidget = this.$store.state.widget.widgetList.find(val => val.id === this.selectWidgetId);
            if (!currentWidget) {
                return 0;
            }
            return currentWidget.boundingClientRect.left;
        },
        top() {
            const currentWidget = this.$store.state.widget.widgetList.find(val => val.id === this.selectWidgetId);
            if (!currentWidget) {
                return 0;
            }
            return currentWidget.boundingClientRect.top;
        },
    },
    beforeDestroy() {
        this.handleClearMousemove();
    },
    mounted() {
        //document.documentElement.addEventListener("mouseup", this.handleClearMousemove);
    },
    methods: {
        //=====================================获取远程数据==================================//

        //=====================================前后端交互====================================//

        //=====================================组件间交互====================================//  
        // 处理缩放
        resizeDOM(e, dir) {
            e.stopPropagation();
            this.startX = e.clientX;
            this.startY = e.clientY;
            this.startLeft = this.left;
            this.startTop = this.top;
            this.startWidth = this.width;
            this.startHeight = this.height;
            /*eslint-disable indent*/ 
            switch (dir) {
                case "left":
                    document.documentElement.addEventListener("mousemove", this.resizeLeft);
                    break;
                case "right":
                    document.documentElement.addEventListener("mousemove", this.resizeRight);
                    break;
                case "top":
                    document.documentElement.addEventListener("mousemove", this.resizeTop);
                    break;
                case "bottom":
                    document.documentElement.addEventListener("mousemove", this.resizeBottom);
                    break;
                case "leftTop":
                    document.documentElement.addEventListener("mousemove", this.resizeLeftTop);
                    break;
                case "leftBottom":
                    document.documentElement.addEventListener("mousemove", this.resizeLeftBottom);
                    break;
                case "rightTop":
                    document.documentElement.addEventListener("mousemove", this.resizeRightTop);
                    break;
                case "rightBottom":
                    document.documentElement.addEventListener("mousemove", this.resizeRightBottom);
                    break;
                default:
                    break;
            }
        },
        //拖拽左侧
        resizeLeft(e) {
            e.stopPropagation();
            e.preventDefault();
            const moveLeft = this.startX - e.clientX;
            this.$store.commit("changeWidgetBoundingClientRect", {
                id: this.selectWidgetId,
                width: this.startWidth + moveLeft,
                left: this.startLeft - moveLeft,
            });
        },
        // 拖动右侧
        resizeRight(e) {
            console.log("right")
            e.stopPropagation();
            e.preventDefault();
            const moveRight = e.clientX - this.startX;
            this.$store.commit("changeWidgetBoundingClientRect", {
                id: this.selectWidgetId,
                width: this.startWidth + moveRight,
            });
        },
        // 拖拽上面
        resizeTop(e) {
            e.stopPropagation();
            e.preventDefault();
            const moveTop = this.startY - e.clientY;
            this.$store.commit("changeWidgetBoundingClientRect", {
                id: this.selectWidgetId,
                height: this.startHeight + moveTop,
                top: this.startTop - moveTop
            });
        },
        // 拖拽下面
        resizeBottom(e) {
            e.stopPropagation();
            e.preventDefault();
            const moveTop = e.clientY - this.startY;
            this.$store.commit("changeWidgetBoundingClientRect", {
                id: this.selectWidgetId,
                height: this.startHeight + moveTop,
            });
        },
        // 拖拽左上角
        resizeLeftTop(e) {
            e.stopPropagation();
            e.preventDefault();
            const moveY = this.startY - e.clientY; //往左为正数
            const moveX = this.startX - e.clientX; //往上为正数
            this.$store.commit("changeWidgetBoundingClientRect", {
                id: this.selectWidgetId,
                width: this.startWidth + moveX,
                height: this.startHeight + moveY,
                left: this.startLeft - moveX,
                top: this.startTop - moveY,
            });
        },
        // 拖拽右上角
        resizeRightTop(e) {
            e.stopPropagation();
            e.preventDefault();
            const moveY = this.startY - e.clientY; //往左为正数
            const moveX = this.startX - e.clientX; //往上为正数
            this.$store.commit("changeWidgetBoundingClientRect", {
                id: this.selectWidgetId,
                width: this.startWidth - moveX,
                height: this.startHeight + moveY,
                top: this.startTop - moveY,
            });
        },
        // 拖拽左下角
        resizeLeftBottom(e) {
            e.stopPropagation();
            e.preventDefault();
            const moveY = this.startY - e.clientY; //往左为正数
            const moveX = this.startX - e.clientX; //往上为正数
            this.$store.commit("changeWidgetBoundingClientRect", {
                id: this.selectWidgetId,
                left: this.startLeft - moveX,
                width: this.startWidth + moveX,
                height: this.startHeight - moveY,
            });
        },
        // 拖拽右下角
        resizeRightBottom(e) {
            e.stopPropagation();
            e.preventDefault();
            const moveY = this.startY - e.clientY; //往左为正数
            const moveX = this.startX - e.clientX; //往上为正数
            this.$store.commit("changeWidgetBoundingClientRect", {
                id: this.selectWidgetId,
                width: this.startWidth - moveX,
                height: this.startHeight - moveY,
            });
        },
        handleClearMousemove(e) {
            // e.stopPropagation(); //阻止冒泡会影响时间筛选框关闭
            document.documentElement.removeEventListener("mousemove", this.resizeLeft);
            document.documentElement.removeEventListener("mousemove", this.resizeRight);
            document.documentElement.removeEventListener("mousemove", this.resizeTop);
            document.documentElement.removeEventListener("mousemove", this.resizeBottom);
            document.documentElement.removeEventListener("mousemove", this.resizeLeftTop);
            document.documentElement.removeEventListener("mousemove", this.resizeRightTop);
            document.documentElement.removeEventListener("mousemove", this.resizeLeftBottom);
            document.documentElement.removeEventListener("mousemove", this.resizeRightBottom);
        }
        //=====================================其他操作=====================================//

    }
};
</script>



<style lang="scss">
.s-drag-bar {
    position: fixed;
    width: 100%;
    height: 100%;
    border: 1px solid $theme-color;
    z-index: 20;
    cursor: grab;
    user-select: none;
    .dot {
        width: size(10);
        height: size(10);
        border: 1px solid $theme-color;
        border-radius: 50%;
        position: absolute;
        background: #fff;
        &.lt {
            left: -6px;
            top: -6px;
            cursor: nw-resize;
        }
        &.lb {
            left: -6px;
            bottom: -6px;
            cursor: sw-resize;
        }
        &.rt {
            right: -6px;
            top: -6px;
            cursor: ne-resize;
        }
        &.rb {
            right: -6px;
            bottom: -6px;
            cursor: se-resize;
        }
        &.l {
            left: -6px;
            top: calc(50% - 10px);
            cursor: w-resize;
        }
        &.r {
            right: -6px;
            top: calc(50% - 10px);
            cursor: e-resize;
        }
        &.t {
            left: calc(50% - 10px);
            top: -6px;
            cursor: n-resize;
        }
        &.b {
            left: calc(50% - 10px);
            bottom: -6px;
            cursor: s-resize;
        }
    }
}
</style>
